import { BigNumber } from '@ethersproject/bignumber';
import { useWeb3React } from '@web3-react/core';
import { useMemo } from 'react';

import { INCH_NATIVE_TOKEN_ADDRESS } from '../../constants/tokens';
import { useAppSelector } from '../../store';
import { ApproveStatus, Field } from '../../types';

export const useApproveStatus = (): ApproveStatus => {
  const { account } = useWeb3React();
  const { typedValue, allowance, inputAddress, selectedProtocol } = useAppSelector((state) => ({
    typedValue: state.swap.typedValue,
    inputAddress: state.swap[Field.INPUT],
    selectedProtocol: state.swap.selectedProtocol,
    allowance: state.approve.allowance,
  }));

  return useMemo(() => {
    if (!inputAddress || !account || !typedValue || !selectedProtocol) return ApproveStatus.UNKNOWN;
    // IF IS NATIVE
    if (inputAddress.toLowerCase() === INCH_NATIVE_TOKEN_ADDRESS) {
      return ApproveStatus.NO_APPROVAL_NEEDED;
    }

    // if no data to approve:
    if (!allowance) return ApproveStatus.UNKNOWN;

    if (allowance === ApproveStatus.PENDING) return ApproveStatus.PENDING;

    return BigNumber.from(allowance).lt(BigNumber.from(typedValue))
      ? ApproveStatus.APPROVAL_NEEDED
      : ApproveStatus.NO_APPROVAL_NEEDED;
  }, [inputAddress, selectedProtocol, typedValue, allowance, account]);
};
